import { render, staticRenderFns } from "./SkillCards.vue?vue&type=template&id=134c4e88&"
import script from "./SkillCards.vue?vue&type=script&lang=js&"
export * from "./SkillCards.vue?vue&type=script&lang=js&"
import style0 from "./SkillCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports